import React from 'react'
import {createUseStyles} from 'react-jss'

import BasicPageHeading from '../components/basic-page-heading'
import Layout from '../components/layouts/layout'
import {combine} from '../styles/classname-utils'
import {MOBILE_VIEW_OVERRIDE} from '../styles/constants'

const useStyles = createUseStyles({
  firstIndent: {
    marginLeft: '1.5rem',
  },

  indent: {
    marginLeft: '1.5rem',
    marginTop: '1.5rem',
  },

  subSection: {
    fontWeight: '700',
  },

  subHeading: {
    '& > h4': {
      marginTop: '1.5rem',
    },
  },

  topParagraph: {
    marginBottom: '2rem',
  },

  heading: {
    marginTop: '3rem',
    [MOBILE_VIEW_OVERRIDE]: {
      marginTop: '2rem',
    },
  },
})

export default () => {
  const classes = useStyles()
  return (
    <Layout title='Terms & Conditions'>
      <BasicPageHeading>
        Terms & Conditions
      </BasicPageHeading>
      <section className='light'>
        <div className='row'>
          <div className={combine('col-md-10 max-width mx-auto text8-md', classes.subHeading)}>
            <h2 className='text-center'>8th Wall Terms and Conditions</h2>
            <p className={classes.topParagraph}>
              BY CREATING AN
              ACCOUNT WITH 8TH WALL, INC. (&ldquo;WE,&rdquo; &ldquo;US&rdquo;
              &ldquo;OUR&rdquo; OR &ldquo;8TH WALL&rdquo;) AND/OR USING OUR
              SERVICES (DEFINED BELOW), YOU OR THE ENTITY OR COMPANY THAT YOU
              REPRESENT (THE &ldquo;LICENSEE&rdquo;) ARE UNCONDITIONALLY
              CONSENTING TO BE BOUND BY AND ARE BECOMING A PARTY TO THESE TERMS
              AND CONDITIONS (THE &ldquo;AGREEMENT&rdquo;). THIS AGREEMENT
              GOVERNS YOUR USE OF 8TH WALL&rsquo;S SOFTWARE AND TECHNOLOGY IN
              COMPUTERS, MOBILE PHONES/TABLETS, AND OTHER DEVICES (THE
              &ldquo;TECHNOLOGY&rdquo;), ACCESS TO 8TH WALL&rsquo;S PROPRIETARY
              PLATFORM THAT SUPPORTS THE FUNCTIONALITY OF THE TECHNOLOGY (THE
              &ldquo;PLATFORM&rdquo;), USE OF 8TH WALL&rsquo;S HOSTING SERVICES
              FOR HOSTING CONTENT CREATED, UPLOADED, OR SHARED USING THE
              TECHNOLOGY OR PLATFORM (THE &ldquo;HOSTING SERVICES&rdquo;), AND
              OTHER PRODUCTS AND SERVICES THAT 8TH WALL MAY PROVIDE
              (COLLECTIVELY, THE &ldquo;SERVICES&rdquo;). IF YOU ARE ENTERING
              INTO THIS AGREEMENT ON BEHALF OF AN ORGANIZATION OR ENTITY, YOU
              HEREBY REPRESENT AND WARRANT THAT YOU ARE AUTHORIZED TO BIND THAT
              ORGANIZATION OR ENTITY TO THESE TERMS. LICENSEE&rsquo;S DOWNLOAD,
              INSTALLATION OR CONTINUED USE OF THE SERVICES WILL ALSO CONSTITUTE
              ASSENT TO THE TERMS OF THIS AGREEMENT. IF LICENSEE DOES NOT
              UNCONDITIONALLY AGREE TO ALL OF THE TERMS OF THIS AGREEMENT,
              LICENSEE WILL HAVE NO RIGHT TO USE THE TECHNOLOGY AND/OR SERVICES.
              IF THESE TERMS ARE CONSIDERED AN OFFER, ACCEPTANCE IS EXPRESSLY
              LIMITED TO ALL OF THESE TERMS, TO THE EXCLUSION OF ALL OTHER
              TERMS.
            </p>

            <h4 className='font8-black'>1. Accounts.</h4>
            <p>
              Licensee will
              create an account and select a password and user name (&ldquo;8th
              Wall User ID&rdquo;) to access and use the Services. Licensee
              promises to provide accurate, complete and updated account
              information. Licensee will be responsible for maintaining the
              security of Licensee&rsquo;s account, passwords (including but not
              limited to administrative and user passwords) and files, and for
              all uses of Licensee&rsquo;s account with or without
              Licensee&rsquo;s knowledge or consent. Licensee will also cooperate
              with 8th Wall in establishing a password or other procedures for
              verifying that only designated employees of Licensee have access to
              any administrative functions of the Services. Licensee will ensure
              that such designated employees do not transfer their accounts to
              any third party without our prior written consent.
            </p>

            <h4 className='font8-black'>2. Intellectual Property.</h4>
            <p className={classes.firstIndent}>
              <span className={classes.subSection}>
                a. Limited License to Access the Platform.
              </span>
              &nbsp;Subject to full compliance with the terms of
              this Agreement, we hereby grant Licensee a limited, personal,
              non-sublicensable, non-transferable, royalty-free, nonexclusive
              license to use and access the 8th Wall&rsquo;s Platform and online
              portal solely for its internal business purposes.
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>
                b. Limited License to Use the Technology.
              </span>
              &nbsp;Subject
              to full compliance with the terms of this Agreement, we hereby
              grant Licensee a limited, personal, non-sublicensable,
              non-transferable, royalty-free, nonexclusive license to use the
              Technology for the sole purpose of allowing Licensee to build
              (strictly in accordance with our official user documentation)
              software applications or, if 8th Wall permits you to do so, web
              applications on your own website (each an &ldquo;App&rdquo;) and
              that may communicate with the Platform, and for other purposes
              authorized by us in writing.
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>
                c. Limited License to Distribute the Technology in Licensee’s App.
              </span>
              &nbsp;Subject to full
              compliance with the terms of this Agreement, we hereby grant
              Licensee a limited, personal, non-sublicensable, non-transferable,
              royalty-free, nonexclusive license to distribute the Technology in
              object code form only as part of an App, and only subject to an
              end-user license agreement which is at least as protective of our
              proprietary rights in the Technology as those contained in this
              agreement. Without limiting the foregoing, these terms and
              conditions will include terms for 8th Wall&rsquo;s benefit
              regarding (a) restrictions on reverse engineering (to the maximum
              extent permitted by applicable law); (b) disclaimer of warranties;
              and (c) limitation of liability, all of which will be at least as
              beneficial to 8th Wall as those contained herein.
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>
                d. Limited License to Use the Sample Application.
              </span>
              &nbsp;Subject to full compliance with the terms of
              this Agreement, we hereby grant Licensee a limited, personal,
              non-sublicensable, non-transferable, royalty-free, nonexclusive
              license to download and use the sample application available by 8th
              Wall for download (the &ldquo;Sample Application&rdquo;) solely for
              the purpose of evaluating the Sample Application and the
              functionality of the Technology.
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>
                e. Hosting Services.
              </span>
              &nbsp;If Licensee
              elects to use the Hosting Services, (i) Licensee shall also comply
              with the Hosting Services Terms and Conditions below, which are
              incorporated into this Agreement, and (ii) subject to full
              compliance with the terms of this Agreement, we hereby grant
              Licensee a limited, personal, non-sublicensable, non-transferable,
              royalty-free, nonexclusive license to use and access the Hosting
              Services solely for its internal business purposes.
            </p>

            <h4 className='font8-black'>3. Restrictions.</h4>
            <p>
              Licensee will
              not use the Services to create, develop or continue a current or
              proposed program that is competitive with the Technology. If
              Licensee intends at any time to institute such a program, Licensee
              will promptly inform 8th Wall, will not use in that program
              (whether for advice, review or otherwise) any personnel who have
              had access to any part of the Technology, and will not use any part
              of the Technology or any related intellectual property in
              connection with that program. Except in connection with
              Licensee&rsquo;s limited right to distribute the Technology in
              object code form in accordance with Section 2, Licensee will not
              disclose (or allow access to) the Technology (or any information
              derived from them) to any third party and will limit access to the
              Technology (and any derived information) to individuals who are
              developing the App and who are bound by this agreement
              (&ldquo;Authorized Users&rdquo;). In support of this obligation,
              Licensee will apply at least the same security that Licensee uses
              to protect Licensee&rsquo;s own most confidential information.
              Licensee will not (and will not authorize or encourage any third
              party to): (i) reverse engineer or otherwise attempt to discover
              the source code of any aspect of the Services (except to the extent
              such restriction is prohibited by applicable law), (ii) modify,
              translate, or create derivative works based on the Services; (iii)
              except as expressly permitted herein, use the Services for
              timesharing or service bureau purposes or for any purpose other
              than its own use and benefit; or (iv) use the Services other than
              in accordance with this Agreement and in compliance with all
              applicable laws and regulations. Any rights not expressly granted
              are reserved.
            </p>

            <h4 className='font8-black'>4. Changes to the Technology.</h4>
            <p>
              Licensee&rsquo;s
              App will maintain 100%
              compatibility with the Technology and the Platform (including
              changes provided to Licensee by 8th Wall which will be implemented
              in the App promptly thereafter). Licensee understands and agrees
              that we may cease support of old versions or releases of the
              Technology at any time. We may also automatically update the
              version of the Services that Licensee is using, including without
              limitation the Technology installed on each device (each, a
              &ldquo;Device&rdquo;) of Licensee&rsquo;s end users.
            </p>

            <h4 className='font8-black'>5. Fees.</h4>
            <p>
              Certain versions or
              functionalities of the Technology may currently be free of charge,
              but we reserve the right to make certain additional features,
              updates or new versions/releases available only for payment. If
              Licensee chooses to purchase such Services, Licensee will pay 8th
              Wall fees for the applicable Service (&ldquo;Fees&rdquo;). We will
              not charge you any Fees without your prior authorization. Unless
              otherwise agreed to in writing, all Fees will be invoiced monthly
              and all invoices issued under this Agreement are payable in U.S.
              dollars within thirty (30) days from date of invoice. Past due
              invoices are subject to interest on any outstanding balance of the
              lesser of 1.5% per month or the maximum amount permitted by law.
              Licensee will be responsible for all taxes associated with the
              Services (excluding taxes based on 8th Wall&rsquo;s net income).
              All Fees paid are non-refundable and are not subject to
              set-off.
            </p>

            <h4 className='font8-black'>6. Improvements.</h4>
            <p>
              Licensee may
              from time to time provide suggestions, comments or other feedback
              to 8th Wall with respect to the Services (&ldquo;Feedback&rdquo;).
              Feedback, even if designated as confidential by Licensee, shall not
              create any confidentiality obligation for 8th Wall notwithstanding
              anything else. Licensee shall, and hereby does, grant to 8th Wall a
              nonexclusive, worldwide, perpetual, irrevocable, transferable,
              sublicensable, royalty-free, fully paid up license to use and
              exploit the Feedback for any purpose.
            </p>

            <h4 className='font8-black'>7. Confidentiality; Data Collection.</h4>
            <p>
              Each party
              (the &ldquo;Receiving Party&rdquo;) understands that the other
              party (the &ldquo;Disclosing Party&rdquo;) has disclosed or may
              disclose information relating to the Disclosing Party&rsquo;s
              technology or business (hereinafter referred to as
              &ldquo;Proprietary Information&rdquo; of the Disclosing
              Party).
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>
                a. Use and Non-Disclosure.
              </span>
              &nbsp;The
              Receiving Party agrees: (i) not to divulge to any third person any
              such Proprietary Information, (i) to give access to such
              Proprietary information solely to those employees with a need to
              have access thereto for purposes of this Agreement, and (iii) to
              take the same security precautions to protect against disclosure or
              unauthorized use of such Proprietary Information that the party
              takes with its own proprietary information, but in no event will a
              party apply less than reasonable precautions to protect such
              Proprietary Information. The Disclosing Party agrees that the
              foregoing will not apply with respect to any information that the
              Receiving Party can document (a) is or becomes generally available
              to the public without any action by, or involvement of, the
              Receiving Party, or (b) was in its possession or known by it prior
              to receipt from the Disclosing Party, or (c) was rightfully
              disclosed to it without restriction by a third party, or (d) was
              independently developed without use of any Proprietary Information
              of the Disclosing Party. Nothing in this Agreement will prevent the
              Receiving Party from disclosing the Proprietary Information
              pursuant to any judicial or governmental order, provided that the
              Receiving Party gives the Disclosing Party reasonable prior notice
              of such disclosure to contest such order. Notwithstanding anything
              else, 8th Wall is permitted to disclose (including through display
              of Licensee&rsquo;s logo) that Licensee is one of its customers
              (including in its publicity and marketing materials).
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>
                b. Licensee Data.
              </span>
              &nbsp;Licensee agrees and
              hereby consents to 8th Wall&rsquo;s collection of certain data and
              information in connection with Licensee&rsquo;s use of the
              Technology in an App which 8th Wall may use for its business
              purposes (collectively, &ldquo;Licensee Data&rdquo;): &nbsp;For the
              avoidance of doubt, Licensee will retain all right, title and
              interest in and to the Licensee Data, including all intellectual
              property or the legality, reliability, appropriateness, and
              intellectual property ownership or right to use of all Licensee
              Data. Please see our Privacy Policy and Data Processing Addendum to
              learn more about what Licensee Data 8th Wall collects, and how such
              information is used.
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>
                c. End User Data.
              </span>
              &nbsp;Licensee agrees and
              hereby consents to 8th Wall&rsquo;s collection of certain data and
              information in connection with Licensee&rsquo;s end users&rsquo;
              use of the App on a Device, which 8th Wall may use for its business
              purposes (collectively, &ldquo;Device Data&rdquo;): Licensee
              represents and warrants that it (i) has and will obtain all
              consents and permissions (from other Authorized Users as well as
              end users of the App and of each Device) required for Licensee to
              grant the rights and permissions in this Section 7 and to enable
              8th Wall to legally collect, retain and use the data described in
              this Section 7 (including, at a minimum, publishing an appropriate
              privacy policy); and (ii) will comply with all applicable laws,
              rules and regulations (including those relating to export control).
              8th Wall will use commercially reasonable efforts to maintain the
              security and integrity of the Services, Licensee Data and Device
              Data. 8th Wall is not responsible to Licensee for unauthorized
              access to Licensee Data or Device Data or the unauthorized use of
              the Service unless such access is due to 8th Wall&rsquo;s gross
              negligence or willful misconduct. Licensee agrees and acknowledges
              that Licensee Data and Device Data may be irretrievably deleted if
              Licensee&rsquo;s account is ninety (90) days or more delinquent.
              Please see our Privacy Policy and Data Processing Addendum to learn
              more about what Device Data 8th Wall collects, and how such
              information is used.
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>
                d. Aggregated Anonymous Data.
              </span>
              &nbsp;Notwithstanding anything to the contrary,
              Licensee acknowledges and agrees that 8th Wall may (i) internally
              use and modify (but not disclose) Licensee Data and Device Data for
              the purposes of (A) providing the Services and any support or
              consultation services to Licensee and (B) generating Aggregated
              Anonymous Data (as defined below), and (ii) freely use and make
              available Aggregated Anonymous Data for 8th Wall&rsquo;s business
              purposes (including without limitation, for purposes of improving,
              testing, operating, promoting and marketing 8th Wall&rsquo;s
              products and services). &ldquo;Aggregated Anonymous Data&rdquo;
              means data submitted to, collected by, or generated by 8th Wall in
              connection with Licensee&rsquo;s use of the Services, but only in
              aggregate, anonymized form which can in no way be linked
              specifically to Licensee or any individual.
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>
                e. DATA PROCESSING ADDENDUM.
              </span>
              &nbsp;THIS SECTION
              APPLIES IF AND TO THE EXTENT WE PROCESS ANY CUSTOMER PERSONAL DATA
              (AS DEFINED IN THE DPA) OF LICENSEE&rsquo;S CLIENTS OR END USERS
              THAT IS SUBJECT TO THE GDPR (AS DEFINED IN THE DPA) ON YOUR BEHALF.
              BY ENTERING INTO THIS AGREEMENT OR USING OUR SERVICES, YOU HEREBY
              ACCEPT AND AGREE TO ABIDE BY THE TERMS OF THE DATA PROCESSING
              ADDENDUM AT&nbsp;
              <a href='https://www.8thwall.com/dpa' target='_blank' rel='noreferrer noopener'>
                https://www.8thwall.com/dpa
              </a>
              &nbsp;(&ldquo;DPA&rdquo;), WHICH ARE HEREBY
              INCORPORATED BY REFERENCE. For the purposes of the Standard
              Contractual Clauses (as defined in the DPA), Licensee and its
              applicable affiliates are each the data exporter, and
              Licensee&rsquo;s acceptance of this Agreement shall be treated as
              its execution of the Standard Contractual Clauses and applicable
              appendices.
            </p>

            <h4 className='font8-black'>8. Indemnification.</h4>
            <p>
              &nbsp;Licensee
              will defend, indemnify, and hold harmless 8th Wall, its affiliates
              and each of its and its affiliates&rsquo; employees, contractors,
              directors, suppliers and representatives from all liabilities,
              claims, and expenses (including reasonable attorneys&rsquo; fees),
              that arise from or relate to (i) Licensee&rsquo;s, an Authorized
              User&rsquo;s or Licensee&rsquo;s end users&rsquo; use or misuse of
              the Services (ii) Licensee&rsquo;s violation of this Agreement or
              breach of its representations or warranties, (iii) infringement by
              Licensee or any Authorized User of any intellectual property or
              other right of any person or entity, or (iv) a claim alleging that
              Licensee or Licensee&rsquo;s App infringes or violates the rights
              of, or has caused harm to, a third party. 8th Wall reserves the
              right to assume the exclusive defense and control of any matter
              otherwise subject to indemnification by Licensee, in which event
              Licensee will assist and cooperate with 8th Wall in asserting any
              available defenses.
            </p>

            <h4 className='font8-black'>9. DISCLAIMER.</h4>
            <p>
              8TH WALL PROVIDES THE SERVICES &ldquo;AS IS&rdquo; AND WITHOUT WARRANTY OF
              ANY KIND, AND HEREBY DISCLAIMS ALL EXPRESS OR IMPLIED WARRANTIES,
              INCLUDING WITHOUT LIMITATION WARRANTIES OF MERCHANTABILITY, FITNESS
              FOR A PARTICULAR PURPOSE, PERFORMANCE, ACCURACY, RELIABILITY, AND
              NON-INFRINGEMENT. THIS DISCLAIMER OF WARRANTY CONSTITUTES AN
              ESSENTIAL PART OF THIS AGREEMENT. SOME STATES DO NOT ALLOW
              LIMITATIONS ON HOW LONG AN IMPLIED WARRANTY LASTS SO THE FOREGOING
              LIMITATIONS MAY NOT APPLY TO LICENSEE.
            </p>

            <h4 className='font8-black'>10. LIMITATION OF LIABILITY.</h4>
            <p>
              UNDER NO CIRCUMSTANCES AND UNDER NO LEGAL THEORY, INCLUDING, BUT NOT LIMITED
              TO, TORT, CONTRACT, NEGLIGENCE, STRICT LIABILITY, OR OTHERWISE,
              WILL 8TH WALL OR ITS SUPPLIERS OR RESELLERS BE LIABLE TO LICENSEE
              OR ANY OTHER PERSON FOR ANY INDIRECT, SPECIAL, INCIDENTAL, OR
              CONSEQUENTIAL DAMAGES INCLUDING, WITHOUT LIMITATION, DAMAGES FOR
              LOST PROFITS, LOSS OF GOODWILL, ACCURACY OF RESULTS, DEVICE FAILURE
              OR MALFUNCTION, OR DAMAGES RESULTING FROM LICENSEE&rsquo;S USE OF
              THE SERVICES. 8TH WALL&rsquo;S LIABILITY FOR DAMAGES OF ANY KIND
              WHATSOEVER ARISING OUT OF THIS AGREEMENT WILL BE LIMITED TO $100.
              THE FOREGOING WILL NOT APPLY TO DAMAGES FOR BODILY INJURY THAT,
              UNDER APPLICABLE LAW, CANNOT BE SO LIMITED. THE FOREGOING
              LIMITATIONS WILL APPLY EVEN IF LICENSEE HAS BEEN INFORMED OF THE
              POSSIBILITY OF SUCH DAMAGES. SOME STATES DO NOT ALLOW THE EXCLUSION
              OR LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE ABOVE
              LIMITATION AND EXCLUSION MAY NOT APPLY TO LICENSEE.
            </p>

            <h4 className='font8-black'>11. Term; Termination.</h4>
            <p>
              This Agreement is effective as of the date Licensee begins using the Services and
              is effective until terminated in accordance with this Section 11.
              Licensee may terminate this Agreement at any time by removing or
              ceasing all use of the Services. We may terminate this Agreement
              and Licensee&rsquo;s access to the Services at any time and for any
              reason. All licenses granted to Licensee hereunder terminate upon
              termination or expiration of this Agreement. Without limiting the
              foregoing, 8th Wall may suspend or limit Licensee&rsquo;s access to
              or use of the Services if (i) Licensee account is more than sixty
              (60) days past due, or (ii) Licensee&rsquo;s use of the Service
              results in (or is reasonably likely to result in) damage to or
              material degradation of the Service which interferes with 8th
              Wall&rsquo;s ability to provide access to the Service to other
              customers; provided that in the case of subsection (ii): (a) 8th
              Wall will use reasonable good faith efforts to work with Licensee
              to resolve or mitigate the damage or degradation in order to
              resolve the issue without resorting to suspension or limitation;
              (b) prior to any such suspension or limitation, 8th Wall will use
              commercially reasonable efforts to provide notice to Licensee
              describing the nature of the damage or degradation; and (c) 8th
              Wall will reinstate Licensee&rsquo;s use of or access to the
              Services, as applicable, if Licensee remediates the issue within
              thirty (30) days of receipt of such notice. All provisions of this
              Agreement which by their nature should survive termination will
              survive termination, including, without limitation, accrued payment
              obligations (if applicable), ownership provisions, warranty
              disclaimers, indemnity and limitations of liability.
            </p>

            <h4 className='font8-black'>12. Choice of Law; Arbitration.</h4>
            <p>
              This Agreement is governed by and will be construed under the laws of the State of
              California, without regard to the conflicts of laws provisions
              thereof. Any dispute arising from or relating to the subject matter
              of this Agreement will be finally settled in Santa Clara County,
              California, in English, in accordance with the Streamlined
              Arbitration Rules and Procedures of Judicial Arbitration and
              Mediation Services, Inc. (&ldquo;JAMS&rdquo;) then in effect, by one commercial
              arbitrator with substantial experience in resolving intellectual
              property and commercial contract disputes, who will be selected
              from the appropriate list of JAMS arbitrators in accordance with
              such Rules. Judgment upon the award rendered by such arbitrator may
              be entered in any court of competent jurisdiction. Notwithstanding
              the foregoing obligation to arbitrate disputes, each party will
              have the right to pursue injunctive or other equitable relief at
              any time, from any court of competent jurisdiction. For all
              purposes of this Agreement, the parties consent to exclusive
              jurisdiction and venue in the state or federal courts located in,
              respectively, Santa Clara County, California or the Northern
              District of California. Any arbitration under these Terms will take
              place on an individual basis: class arbitrations and class actions
              are not permitted. LICENSEE UNDERSTANDS AND AGREES THAT BY ENTERING
              INTO THESE TERMS, LICENSEE AND 8TH WALL ARE EACH WAIVING THE RIGHT
              TO TRIAL BY JURY OR TO PARTICIPATE IN A CLASS ACTION.
            </p>

            <h4 className='font8-black'>13. Changes to Agreement, Platform, or Service.</h4>
            <p>
              8th Wall may modify the Agreement at any time, in 8th
              Wall&rsquo;s
              sole discretion. If 8th Wall does so, 8th Wall will let Licensee
              know either by posting the modified Agreement on the Platform or
              8th Wall&rsquo;s website or through other communications. It is
              important that Licensee reviews the Agreement whenever 8th Wall
              modifies it because if Licensee continues to use the Platform or
              Services after 8th Wall has notified Licensee of the modification
              and the modified Agreement has been posted on the Platform or 8th
              Wall&rsquo;s website, Licensee is indicating to 8th Wall that
              Licensee agrees to be bound by the modified Agreement. If Licensee
              does not agree to be bound by the modified Agreement, then Licensee
              may not continue to use the Platform or Services. Because the
              Platform and Services are evolving over time, 8th Wall may change
              or discontinue all or any part of the Platform or Services at any
              time and without notice, at 8th Wall&rsquo;s sole
              discretion.
            </p>

            <h4 className='font8-black'>14. Miscellaneous.</h4>
            <p>
              You represent and warrant that you are not located in a country that is
              subject to a U.S. government embargo or that has been designated by
              the U.S. government as a &ldquo;terrorist supporting&rdquo; country
              and that you are not listed on any U.S. government list of
              prohibited or restricted parties. This Agreement represents the
              complete agreement concerning the subject matter hereof between the
              parties and supersedes all prior agreements and representations
              between them. This Agreement may be amended only by a writing
              executed by both parties or as otherwise provided in Section 13. If
              any provision of this Agreement is held to be unenforceable for any
              reason, such provision will be reformed only to the extent
              necessary to make it enforceable. Any notices or other
              communications provided by 8th Wall under this Agreement, including
              those regarding modifications to this Agreement, will be given: (i)
              via email; or (ii) by posting to the Platform. For notices made by
              e-mail, the date of receipt will be deemed the date on which such
              notice is given. For notices made by posting to the Platform, the
              date of such posting will be deemed the date that notice is given.
              The failure of 8th Wall to act with respect to a breach of this
              Agreement by Licensee or others does not constitute a waiver and
              will not limit 8th Wall&rsquo;s rights with respect to such breach
              or any subsequent breaches. This Agreement is personal to Licensee
              and may not be assigned or transferred for any reason whatsoever
              without 8th Wall&rsquo;s consent and any action or conduct in
              violation of the foregoing will be void and without effect. 8th
              Wall expressly reserves the right to assign this Agreement and to
              delegate any of its obligations hereunder.
            </p>

            <p>Please contact <a href='mailto:support@8thwall.com'>support@8thwall.com</a> if you
              have any questions or concerns regarding the Services.
            </p>

            <h2 className={combine('text-center', classes.heading)}>
              Hosting Services Terms &amp; Conditions
            </h2>

            <p>8th Wall also
              offers hosting services that enable you to upload and share
              content, including any content created using the Technology and
              Platform, via 8th Wall&rsquo;s website, located at{' '}
              <a
                href='https://www.8thwall.com'
                target='_blank'
                rel='noopener noreferrer'
              >
                https://www.8thwall.com
              </a>
              {' '}(the “Hosting
              Services”). Your use of the Hosting Services is at all times subject to the 8th Wall
              Terms and Conditions({' '}
              <a
                href='https://www.8thwall.com/terms'
                target='_blank'
                rel='noopener noreferrer'
              >
                https://www.8thwall.com/terms
              </a>)
              , and any capitalized terms used herein
              shall have the same meaning as in the 8th Wall Terms and Conditions.
              The following additional terms also apply to your use of the Hosting Services:
            </p>

            <h4 className='font8-black'>1. Restrictions.</h4>
            <p>
              You represent, warrant, and agree that you will not contribute any
              Content (defined below) or otherwise use the Hosting Services or
              interact with the Hosting Services in a manner that:
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>a. </span>
              Infringes or violates the intellectual property rights or any other
              rights of anyone else (including 8th Wall);
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>b. </span>
              Violates any law or regulation, including any applicable export control laws;
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>c. </span>
              Is harmful, fraudulent, deceptive, threatening, harassing, defamatory, obscene,
              or otherwise objectionable;
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>d. </span>
              Jeopardizes the security of your 8th Wall account or anyone else&rsquo;s (such as
              allowing someone else to log in to the Hosting Services as
              you);
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>e. </span>
              Attempts, in any manner, to obtain the password, account, or other security
              information from any other user;
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>f. </span>
              Tracks or collects data about other users (such as usage data or any personal
              data), including, without limitation, tracking other users&rsquo;
              cookies or log-in codes.
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>g. </span>
              Violates the security of any computer network, or cracks any passwords or
              security encryption codes;
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>h. </span>
              Runs Maillist, Listserv, any form of auto-responder or &ldquo;spam&rdquo; on the
              Hosting Services, or any processes that run or are activated while
              you are not logged into the Hosting Services, or that otherwise
              interfere with the proper working of 8th Wall&rsquo;s Services
              (including by placing an unreasonable load on the Hosting
              Service&rsquo;s infrastructure, such as through crypto
              mining);
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>i. </span>
              &ldquo;Crawls,&rdquo; &ldquo;scrapes,&rdquo; or
              &ldquo;spiders&rdquo; any page, data, or portion of or relating to
              the Hosting Services or Content (through use of manual or automated
              means);
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>j. </span>
              Copies or stores any significant portion of the Content;
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>k. </span>
              Decompiles, reverse engineers, or otherwise attempts to obtain the source code
              or underlying ideas or information of or relating to the Hosting
              Services;
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>l. </span>
              Circumvents any security or safety measures or other technological restrictions 8th
              Wall has put in place in the Hosting Services.
            </p>

            <p>A violation of any
              of the foregoing is grounds for termination of your right to use or
              access the Hosting Services.
            </p>

            <h4 className='font8-black'>2. Use of the Hosting Services.</h4>
            <p>
              The materials displayed or performed or available on or through the Hosting
              Services, including, but not limited to, augmented reality content,
              text, videos, graphics, data, articles, photos, images,
              illustrations, textures, meshes, code and scripts, Your Content
              (defined below), and so forth (all of the foregoing, the
              &ldquo;Content&rdquo;) are protected by copyright and/or other
              intellectual property laws. You promise to abide by all copyright
              notices, trademark rules, information, and restrictions contained
              in any Content you access through the Hosting Services, and you
              will not use, copy, reproduce, modify, translate, publish,
              broadcast, transmit, distribute, perform, upload, display, license,
              sell or otherwise exploit for any purpose any Content not owned by
              you, (i) without the prior consent of the owner of that Content or
              (ii) in a way that violates someone else&rsquo;s (including 8th
              Wall&rsquo;s) rights.
            </p>

            <p>You understand that
              8th Wall owns the Hosting Services. You will not modify, publish,
              transmit, participate in the transfer or sale of, reproduce (except
              as expressly provided in this Section), create derivative works
              based on, or otherwise exploit any of the Hosting
              Services.
            </p>

            <p>You agree not to
              distribute in any medium any part of the Hosting Services or the
              Content without 8th Wall&rsquo;s prior written authorization,
              unless 8th Wall makes available the means for such distribution
              through functionality offered by the Hosting Services (such as the
              features that enable you to embed Content on your own
              website).
            </p>

            <p>8th Wall reserves
              the right to decide whether any Content violates these Hosting
              Services Terms and Conditions, and 8th Wall may at any time,
              without prior notice and in its sole discretion, remove any Content
              from the Hosting Services for any reason.
            </p>

            <h4 className='font8-black'>3. Commercial Uses.</h4>
            <p>
              You agree not to use the Hosting Services for any of the following commercial uses
              unless you obtain 8th Wall&rsquo;s prior written
              approval:
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>a. </span>
              the sale of access to the Hosting Services;
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>b. </span>
              the sale of advertising, sponsorships, or promotions placed on or
              within the Hosting Services or Content.
            </p>

            <p>
              Prohibited commercial uses do not include uploading original Content to the Hosting
              Services to promote your business or artistic enterprise.
            </p>

            <h4 className='font8-black'>4. Licenses.</h4>
            <p>
              Anything you post, upload, share, store, or otherwise provide through the
              Hosting Services is &ldquo;Your Content.&rdquo; In order to display
              Your Content on the Hosting Services, and to allow other users to
              enjoy them (where applicable), you grant us certain rights in Your
              Content. Please note that all of the following licenses are subject
              to our Privacy Policy (
              <a
                href='https://www.8thwall.com/privacy'
                target='_blank'
                rel='noreferrer noopener'
              >
                https://www.8thwall.com/privacy
              </a>
              ) to the
              extent they relate to Your Content that contains your
              personally-identifiable information.
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>a. </span>
              For all of Your Content, you hereby grant 8th Wall a license to translate, modify
              (for technical purposes, for example making sure your content is
              viewable on an iPhone as well as a computer) and reproduce and
              otherwise act with respect to Your Content, in each case to enable
              us to operate the Hosting Services, as described in more detail
              below. This is a license only &ndash; your ownership in Your
              Content is not affected.
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>b. </span>
              You may have the ability to store Your Content in your own personal 8th Wall
              account, in a manner that is not viewable by any other user except
              you (&ldquo;Personal Content&rdquo;). If you create or store such
              Personal Content on the Hosting Services, then you grant 8th Wall
              the license above, as well as a license to display, perform, and
              distribute your Personal Content for the sole purpose of making
              that Personal Content accessible to you and providing the Hosting
              Services necessary to do so.
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>c. </span>
              You may have the ability to share Your Content only in a manner that only certain
              specified users can view (for example, a private upload to one or
              more other users) (&ldquo;Limited Audience Content&rdquo;). If you
              create, store, or share such Limited Audience Content on the
              Hosting Services, then you grant 8th Wall the licenses above, as
              well as a license to display, perform, and distribute your Limited
              Audience Content for the sole purpose of making that Limited
              Audience Content accessible to such other specified users, and
              providing the Hosting Services necessary to do so. Also, you grant
              such other specified users a license to access that Limited
              Audience Content, and to use and exercise all rights in it, as
              permitted by the functionality of the Hosting Services. If you are
              uploading Content you did not create or own, you are responsible
              for ensuring that the Content you upload is licensed under terms
              that grant these permissions to such other specified
              users.
            </p>

            <p className={classes.indent}>
              <span className={classes.subSection}>d. </span>
              If you share Your Content publicly on the Hosting Services and/or in a manner
              that more than just you or certain specified users can view
              (&ldquo;Public Content&rdquo;), then you grant 8th Wall the
              licenses above, as well as a license to use, reproduce, prepare
              derivative works of, display, perform, and distribute your Public
              Content for the purpose of making that Public Content accessible to
              all 8th Wall users and providing the Hosting Services necessary to
              do so, as well as all other rights necessary to use and exercise
              all rights in that Public Content in connection with 8th
              Wall&rsquo;s business, including without limitation for promoting
              and redistributing part or all of the Hosting Services (and
              derivative works thereof) in any media formats and through any
              media channels. However, 8th Wall will try to notify you if it uses
              your Public Content for its own advertising and promotional
              purposes. Also, you grant all other users of the Hosting Services a
              license to access that Public Content, and to use and exercise all
              rights in it, as permitted by the functionality of the Hosting
              Services. If you are uploading Content you did not create or own,
              you are responsible for ensuring that the Content you upload is
              licensed under terms that grant these permissions to all other
              users of the Hosting Services.
            </p>

            <p>
              You agree that the
              licenses you grant are royalty-free, perpetual, sublicenseable and
              transferable, irrevocable, and worldwide.
            </p>

            <p>
              You agree that 8th Wall may display advertising embedded in, in proximity to, or
              otherwise in connection with displaying Your Content on the Hosting
              Services, and you will not be entitled to any payments in
              connection with such advertising. Finally, you understand and agree
              that 8th Wall, in performing the required technical steps to
              provide the Hosting Services to our users (including you), may need
              to make changes to Your Content to conform and adapt Your Content
              to the technical requirements of connection networks, devices,
              services, or media, and the foregoing licenses include the rights
              to do so.
            </p>

            <h4 className='font8-black'>5. DMCA Takedown.</h4>
            <p>
              You may have heard of the Digital Millennium Copyright Act (the
              &ldquo;DMCA&rdquo;), as it relates to online service providers,
              like 8th Wall, being asked to remove material that allegedly
              violates someone&rsquo;s copyright. We respect others&rsquo;
              intellectual property rights, and we reserve the right to delete or
              disable Content alleged to be infringing, and to terminate the
              accounts of repeat alleged infringers; to review our complete
              Copyright Dispute Policy and learn how to report potentially
              infringing content, click&nbsp;
              <a
                href='https://www.8thwall.com/copyright-dispute-policy'
                target='_blank'
                rel='noopener noreferrer'
              >
                here
              </a>
              . To learn
              more about the DMCA, click{' '}
              <a
                href='https://www.copyright.gov/legislation/dmca.pdf'
                target='_blank'
                rel='noopener noreferrer'
              >
                here
              </a>
              .
            </p>

            <h4 className='font8-black'>6. User Risks and Responsibilities.</h4>
            <p>
              Any information or Content publicly posted or privately transmitted
              through or on the Hosting Services is the sole responsibility of
              the person from whom such content originated, and you access all
              such information and content at your own risk. 8th Wall is not
              liable for any errors or omissions in that information or content
              or for any damages or loss you might suffer in connection with it.
              We cannot control and have no duty to take any action regarding how
              you may interpret and use the Content or what actions you may take
              as a result of having been exposed to the Content, and you hereby
              release us from all liability for you having acquired or not
              acquired Content through the Hosting Services. 8th Wall cannot
              guarantee the identity of any users with whom you interact in using
              the Hosting Services and is not responsible for which users gain
              access to the Hosting Services.
            </p>

            <p>You are responsible
              for all Content you contribute, in any manner, to the Hosting
              Services, and you represent and warrant you have all rights
              necessary to do so, in the manner in which you contribute it. You
              will keep all your registration information accurate and current.
              You are responsible for all your activity in connection with the
              Hosting Services.
            </p>

            <h4 className='font8-black'>7. Interactions with Third Parties.</h4>
            <p>
              The Hosting Services may contain links or connections to third party websites
              or services that are not owned or controlled by 8th Wall. When you
              access third party websites or use third party services, you accept
              that there are risks in doing so, and that 8th Wall is not
              responsible for such risks. We encourage you to be aware when you
              leave the Hosting Services and to read the terms and conditions and
              privacy policy of each third party website or service that you
              visit or utilize.
            </p>

            <p>8th Wall has no
              control over, and assumes no responsibility for, the content,
              accuracy, privacy policies, or practices of or opinions expressed
              in any third party websites or by any third party that you interact
              with through the Hosting Services. In addition, 8th Wall will not
              and cannot monitor, verify, censor or edit the content of any third
              party site or service. By using the Hosting Services, you release
              and hold us harmless from any and all liability arising from your
              use of any third party website or service.
            </p>

            <p>Your interactions
              with organizations and/or individuals found on or through the
              Hosting Services, including payment and delivery of goods or
              services, and any other terms, conditions, warranties or
              representations associated with such dealings, are solely between
              you and such organizations and/or individuals. You should make
              whatever investigation you feel necessary or appropriate before
              proceeding with any online or offline transaction with any of these
              third parties. You agree that 8th Wall shall not be responsible or
              liable for any loss or damage of any sort incurred as the result of
              any such dealings.
            </p>

            <p>If there is a
              dispute between participants using the Hosting Services, or between
              users and any third party, you agree that 8th Wall is under no
              obligation to become involved. In the event that you have a dispute
              with one or more other users, you release 8th Wall, its officers,
              employees, agents, and successors from claims, demands, and damages
              of every kind or nature, known or unknown, suspected or
              unsuspected, disclosed or undisclosed, arising out of or in any way
              related to such disputes and/or our Services. If you are a
              California resident, you shall and hereby do waive California Civil
              Code Section 1542, which says: &ldquo;A general release does not extend
              to claims which the creditor does not know or suspect to exist in
              his or her favor at the time of executing the release, which, if
              known by him or her must have materially affected his or her
              settlement with the debtor.&rdquo;
            </p>
          </div>
        </div>
      </section>
    </Layout>
  )
}
